// Document parser orchestrator - routes files to correct parser

import { ParsedDocument } from '../types/document'
import { getFileExtension } from '../utils/fileValidation'
import { parseTxt, parseDocx, parseRtf, parsePages } from './parsers'
import { parseDocServer } from './docConversionService'
import { extractTextFromPdf } from './parsers/pdfTextExtractor'

async function extractTextSafe(arrayBuffer: ArrayBuffer): Promise<string> {
  try {
    return await extractTextFromPdf(arrayBuffer)
  } catch (e) {
    console.warn('PDF text extraction failed:', e)
    return ''
  }
}

export async function parseDocument(file: File): Promise<ParsedDocument> {
  const ext = getFileExtension(file.name)

  switch (ext) {
    case 'txt':
      return { type: 'text', content: await parseTxt(file) }

    case 'pdf': {
      const data = await file.arrayBuffer()
      // Clone buffer for extraction since pdfjs may detach the original
      const extractedText = await extractTextSafe(data.slice(0))
      return { type: 'pdf', data, extractedText }
    }

    case 'docx':
      return { type: 'text', content: await parseDocx(file) }

    case 'rtf':
      return { type: 'text', content: await parseRtf(file) }

    case 'doc':
      return { type: 'text', content: await parseDocServer(file) }

    case 'pages': {
      const data = await parsePages(file)
      // Clone buffer for extraction since pdfjs may detach the original
      const extractedText = await extractTextSafe(data.slice(0))
      return { type: 'pdf', data, extractedText }
    }

    default:
      throw new Error(`Unsupported file format: ${ext}`)
  }
}
